<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="search"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <v-btn small color="primary" @click="$emit('form')">
        {{ $t('action.buttons.new') }}
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        :search="search"
        disable-initial-sort
      >
        <!--      :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"-->
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item._id)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.photo" alt />
            </v-avatar>
          </td>
          <td>{{ props.item.name }}</td>
          <!-- <td>{{props.item.pitches}}</td> -->
          <td>{{ props.item.country }}</td>
          <td>{{ props.item.province }}</td>
          <td>{{ props.item.town }}</td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'StadiumList',
  components: { DialogDelete, DialogUpdatedRecord },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    // search(val) {
    //   if (this.localPagination.page !== 1) this.localPagination.page = 1
    //   else this.debounceFetch()
    // },
    // 'localPagination.page': {
    //   handler: function(val, oldVal) {
    //     // this.fetchList({ match: this.search })
    //   }
    // }
  },
  computed: {
    ...mapState({
      loading: (state) => state.stadiums.loading,
      selected: (state) => state.stadiums.selected,
      pagination: (state) => state.stadiums.pagination,
    }),
    ...mapGetters({
      formatedList: 'stadiums/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.users.image'),
          value: 'photo',
          align: 'center',
        },
        {
          text: this.$t('fields.global.name'),
          align: 'center',
          value: 'name',
        },
        // {
        //   text: this.$tc('models.pitch', 2),
        //   align: 'center',
        //   value: 'pitch'
        // },
        {
          text: this.$tc('models.country'),
          align: 'center',
          value: 'country',
        },
        {
          text: this.$tc('models.province'),
          align: 'center',
          value: 'province',
        },
        {
          text: this.$tc('models.town'),
          align: 'center',
          value: 'town',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          align: 'center',
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('stadiums/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'stadiums/fetchOne',
      setDelete: 'stadiums/delete',
      reset: 'stadiums/reset',
      fetchList: 'stadiums/fetchList',
    }),
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then((_) => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then((_) => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      // this.fetchList({
      //   match: this.search
      // })
    }, 1000),
  },
}
</script>
